
// TODO: replace with the API data once the reviews and merchandise endpoints are available (mirrors the launchpad template)

export interface IReview {
    id: number;
    text: string;
    author: string;
    avatar: string;
    rating: number;
    tournament: string;
}

export interface IMerchItem {
    id: number;
    img: string;
    name: string;
    price: number;
    category: string;
    badge: string | null;
}

export const REVIEWS: IReview[] = [
    { id: 1, author: "ProGamer_BR", avatar: "https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?w=120&q=80", rating: 5, tournament: "Grand Prix Open", text: "The production quality was absolutely world class. Every match felt like a main stage event — we will be back every year." },
    { id: 2, author: "TeamCaptain99", avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&q=80", rating: 5, tournament: "Amateur League", text: "Registration was seamless, the rules were clear and the referee team was professional throughout. They genuinely care about fair competition." },
    { id: 3, author: "StreamerKing", avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=120&q=80", rating: 4, tournament: "World Championship", text: "Amazing broadcast quality and production value. The observer work during the finals was cinematic from start to finish." },
    { id: 4, author: "AnalystMaria", avatar: "https://images.unsplash.com/photo-1545996124-0501ebae84d0?w=120&q=80", rating: 5, tournament: "Summit", text: "Incredible speakers and real, actionable content. The best esports gathering I have attended in years." },
];

export const MERCH: IMerchItem[] = [
    { id: 1, name: "Championship Hoodie", category: "Apparel", price: 64.99, img: "https://images.unsplash.com/photo-1556821840-3a63f15732ce?w=500&q=80", badge: "New" },
    { id: 2, name: "Official Event Jersey", category: "Apparel", price: 54.99, img: "https://images.unsplash.com/photo-1620794108219-aedbde4e6fb0?w=500&q=80", badge: null },
    { id: 3, name: "Snapback Cap", category: "Accessories", price: 29.99, img: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=500&q=80", badge: "Hot" },
    { id: 4, name: "Trophy Replica", category: "Collectibles", price: 149.99, img: "https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=500&q=80", badge: "Limited" },
    { id: 5, name: "Gaming Mouse Pad XL", category: "Accessories", price: 24.99, img: "https://images.unsplash.com/photo-1599481238640-4c1288750d7a?w=500&q=80", badge: null },
    { id: 6, name: "World Champ Tee", category: "Apparel", price: 34.99, img: "https://images.unsplash.com/photo-1571945192063-40f7fd5f7a49?w=500&q=80", badge: null },
];
